module.exports = __webpack_public_path__ + "static/media/header-mobile.0cd35ed1.jpg";